// paquetes
import {useLocation,  useParams, useNavigate, useOutletContext} from 'react-router-dom';
import React, {useState, useEffect } from "react";
import axios from "axios";
import Swal from 'sweetalert2';
// componentes
import ZonaCargando from '../../alertas/zonaCargando';
// estilos
import '../../../estilos/usuario.css';
import PagoIndividual from '../vendedor/pagoIndividual';



function PagosComprador() {
    const { usuario, setUsuario, cargandoUsuario } = useOutletContext() || {}; // variables que vienen de direccionameinto 
    const navigate                      = useNavigate();
    
    // Variables
    const [cargando, setCargando]  = useState(false);
    const cargandoFinal            = Boolean(cargandoUsuario) || Boolean(cargando);
    const [reservas, setReservas]  = useState(null);
    const [paginaActual, setPaginaActual] = useState(1);
    const RESERVAS_POR_PAGINA = 5;


    useEffect(() => {
        (async () => {
            if (cargandoUsuario) return; // Espera a que Direccionamiento termine de cargar sesión

            // Si no hay usuario, esta página requiere login
            if (!usuario) { return navigate("/iniciar-sesion"); }

            // Hidratamos el perfil desde el usuario global
            try {
                setCargando(true);
                const resReservas = await axios.post("/obtener-todas-reservas", {
                    params: {
                        idUsuario: usuario.idUsuario,
                        tipo: "COMPRADOR",
                        pagina: paginaActual,
                        limite: RESERVAS_POR_PAGINA,
                        desdeDonde: "pagos",
                    }
                });

                //console.log("resReservas: ", resReservas);
                const reservasAusar = resReservas.data.reservas;
                if(reservasAusar.length > 0){ setReservas(reservasAusar); }
                else{ setReservas([]); }
            }
            finally { setCargando(false); }
        })();
    }, [usuario, cargandoUsuario, paginaActual]);
    

    const totalPaginas = 1;



    function verPagoIndividual(idReserva){
        return navigate('/usuario/pago-individual', {
            state: { idReserva }
        });
    }


    return(
    <div >
    { (cargandoFinal) ? <ZonaCargando />
    :  usuario ? 
    <div className='d-flex flex-row '>
        {/* Columna 2 */}
        <div className="flex-grow-1 container-fluid contenedorAdaptador ">     
            {/* Contenedor título  */}
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom border-dark">
                <div className="container">
                    <div className="d-flex justify-content-between align-items-center flex-wrap">
                        {/* título */}
                        <h1 className="h2 text-dark mb-0">Pagos</h1>
                    </div>
                </div>
            </div>


            {!reservas || reservas.length === 0 ? 
            <div className='container'>
                <p>Aún no haz realizado ninguna compra. Te invitamos a visitar nuestro home o búsqueda para realizar una compra.</p>
            </div> 
            : <div className='container mb-5'>

                <p>Aquí puedes ver los pagos que has realizado.</p>

                <div className='row g-3'>
                    {reservas.map((reserva) => {
                        const totalCompra    = reserva?.cobro?.monto || reserva?.cobro?.montoTotal || 0;
                        const idPago         = reserva?.cobro?.idPago || "";
                        const fechaCompraRaw = reserva?.cobro?.fechaPago || reserva?.updatedAt || reserva?.createdAt || null;
                        const metodoPago     = reserva?.cobro?.metodoPagoTipo || 'No disponible';
                        const estadoPago     = reserva?.cobro?.estadoPago || 'No disponible';
                        const fechaCompra    = fechaCompraRaw
                            ? new Date(fechaCompraRaw).toLocaleDateString('es-CO', {
                                year: 'numeric',
                                month: 'long',
                                day: 'numeric',
                              })
                            : 'Fecha no disponible';

                        return (
                            <div className='col-12' key={reserva._id}>
                                <div
                                    className='card shadow-sm border-0 rounded-4'
                                    style={{ backgroundColor: 'var(--color-bg-surface)' }}
                                >
                                    <div className='card-body p-4'>
                                        <div className='d-flex flex-column flex-lg-row justify-content-between align-items-lg-center gap-4'>
                                            <div className='d-flex flex-column flex-md-row gap-4 gap-md-5'>
                                                <div>
                                                    <p className='text-muted mb-1'>Total de la compra</p>
                                                    <h4 className='mb-0 text-dark'>
                                                        {Number(totalCompra).toLocaleString('es-CO', {
                                                            style: 'currency',
                                                            currency: reserva?.cobro?.moneda || 'COP',
                                                            maximumFractionDigits: 0,
                                                        })}
                                                    </h4>
                                                </div>

                                                <div>
                                                    <p className='text-muted mb-1'>Fecha de la compra</p>
                                                    <p className='mb-0 text-dark fw-semibold'>{fechaCompra}</p>
                                                </div>

                                                <div>
                                                    <p className='text-muted mb-1'>Método de pago</p>
                                                    <p className='mb-0 text-dark fw-semibold text-uppercase'>{metodoPago}</p>
                                                </div>

                                                <div>
                                                    <p className='text-muted mb-1'>Estado del pago</p>
                                                    <p className='mb-0 text-dark fw-semibold text-uppercase'>{estadoPago}</p>
                                                </div>
                                            </div>

                                            <button
                                                type='button'
                                                className='btn btn-primary rounded-pill px-4'
                                                onClick={() => verPagoIndividual(reserva._id)}
                                            >
                                                Ver más detalles de compra
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>

                <div className='d-flex justify-content-center align-items-center gap-2 flex-wrap mt-4'>
                    <button
                        type='button'
                        className='btn btn-outline-primary rounded-pill px-4'
                        disabled={paginaActual === 1}
                        onClick={() => setPaginaActual((prev) => Math.max(prev - 1, 1))}
                    >
                        Anterior
                    </button>

                    <span className='text-dark fw-semibold'>
                        Página {paginaActual}
                    </span>

                    <button
                        type='button'
                        className='btn btn-outline-primary rounded-pill px-4'
                        disabled={!reservas || reservas.length < RESERVAS_POR_PAGINA}
                        onClick={() => setPaginaActual((prev) => prev + 1)}
                    >
                        Siguiente
                    </button>
                </div>
            </div>
            }            
        </div>
    </div>
    : null
    }
    </div>  
    )
}
  
  
  
export default PagosComprador;